'use client';

import Link from 'next/link';
import Image from 'next/image';
import { useLanguage } from '@/doi-tac-module/contexts/LanguageContext';
import { agencyTranslations } from '@/doi-tac-module/constants/agency-translations';

const Logo = () => (
    <Image src="/img/HJPNG.png" alt="HelloJob Logo" width={110} height={36} className="h-9 w-auto" />
);

export function AgencyFooter() {
  const { language } = useLanguage();
  const t = agencyTranslations.footer;

  return (
    <footer className="bg-secondary text-secondary-foreground">
      <div className="container mx-auto px-4 md:px-6 py-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <Link href="/doi-tac" className="flex items-center gap-2 mb-4">
              <Logo />
            </Link>
            <p className="text-sm text-muted-foreground">
              {t.desc[language]}
            </p>
          </div>
          <div>
            <h4 className="font-bold mb-4">{t.forAgency[language]}</h4>
            <ul className="space-y-2 text-sm font-medium">
              <li><Link href="/doi-tac/viec-lam" className="hover:text-primary transition-colors">{agencyTranslations.cta.manageJobs[language]}</Link></li>
              <li><Link href="/doi-tac/nhap-lieu" className="hover:text-primary transition-colors">{t.fastEntry[language]}</Link></li>
              <li><Link href="/tim-viec-lam" className="hover:text-primary transition-colors">{t.newsBoard[language]}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-4">{t.resources[language]}</h4>
            <ul className="space-y-2 text-sm">
              <li><Link href="/gioi-thieu" className="hover:text-primary transition-colors transition-all">{t.about[language]}</Link></li>
              <li><Link href="/policy" className="hover:text-primary transition-colors transition-all">{t.privacy[language]}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-4">{t.support[language]}</h4>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Email: agency.hq@hellojob.jp<br />
              Hotline: (+84) 038 666 7 999
            </p>
          </div>
        </div>
        <div className="mt-8 border-t pt-4 text-center text-sm text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} HelloJob Agency Hub. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}
